import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useBlocker } from "react-router-dom";

// 1. Week navigation hook
export function useWeekNavigation() {
    const now = moment();
    const monday = now.clone().weekday(1);
    const saturday = now.clone().weekday(6);
    const [startDate, setStartDate] = useState(monday);
    const [endDate, setEndDate] = useState(saturday);

    const goToNextWeek = useCallback(() => {
        setStartDate((prev) => prev.clone().add({ week: 1 }));
        setEndDate((prev) => prev.clone().add({ week: 1 }));
    }, []);
    const goToPrevWeek = useCallback(() => {
        setStartDate((prev) => prev.clone().subtract({ week: 1 }));
        setEndDate((prev) => prev.clone().subtract({ week: 1 }));
    }, []);
    const goToThisWeek = useCallback(() => {
        setStartDate(monday);
        setEndDate(saturday);
    }, [monday, saturday]);

    return { startDate, endDate, setStartDate, setEndDate, goToNextWeek, goToPrevWeek, goToThisWeek };
}

// 2. Blocker logic with shouldBlock
export function useBlockerWithChanges(modifiedSlotList) {
    const shouldBlock = useMemo(() => {
        return modifiedSlotList.filter((el) => el.newSlot || el.updated).length > 0;
    }, [modifiedSlotList]);

    const blocker = useBlocker((tx) => {
        return tx.currentLocation !== tx.nextLocation && shouldBlock;
    });

    return { blocker, shouldBlock };
}

// 3. Timeslot mutation logic (side effects for add/update)
export function useTimeslotMutations({ setSlotMutating, updateSlotMutating, alert, blocker, setModifiedSlotList }) {
    useEffect(() => {
        if (setSlotMutating.isSuccess) {
            blocker.proceed?.();
            setModifiedSlotList([]);
        }
        if (setSlotMutating.isError) alert.error("An error occured when adding timeslot");
    }, [alert, blocker, setSlotMutating, setModifiedSlotList]);

    useEffect(() => {
        if (updateSlotMutating.isSuccess) {
            blocker.proceed?.();
            setModifiedSlotList([]);
        }
        if (updateSlotMutating.isError) alert.error("An error occured when updating timeslot");
    }, [alert, blocker, updateSlotMutating, setModifiedSlotList]);
}
